import { createTheme, PaletteColorOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface CustomPalette {
    primary: PaletteColorOptions;
    secondary: PaletteColorOptions;
    gray: PaletteColorOptions;
  }
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    primary: true;
    secondary: true;
    gray: true;
  }
}

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor: string) => augmentColor({ color: { main: mainColor } });

export const theme = createTheme({
  palette: {
    primary: createColor('#1976d2'),
    secondary: createColor('#4CAF50'),
    gray: createColor('#f1f1f1'),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // root: {
        //   '&:hover': {
        //     backgroundColor: 'rgba(25, 118, 210, 0.8)',
        //   },
        // },
        containedPrimary: {
          '&:hover': {
            backgroundColor: 'rgb(30,136,229)',
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: 'rgb(0, 200, 83)',
          },
        },
      },
    },
  },
});
